import React, { useContext, useEffect, useState } from 'react';
import {
  List,
  Card,
  Select,
  Row,
  Col,
  Form,
  Steps,
  Badge,
  message,
  Button,
  Tag
} from 'antd';
import {
  getPassedExams,
  getPassedStudentExams,
  teacherSubjects,
  getTeacherGroups,
  getStudentAnswers,
  setCheckedAnswer,
  collectTotal,
} from '../../../actions';
import Question from './question';
import { Context } from '../../../defaults';
import moment from 'moment';

const { Step } = Steps;

const CheckExam = () => {
  const { dictionary, language, setLoading, storageCheckExam } = useContext(
    Context
  );
  const [selectedExams, setSelectedExams] = useState([]);
  const [exams, setExams] = useState([]);
  const [examId, setExamId] = useState();
  const [current, setCurrent] = useState(0);
  const [question, setQuestion] = useState({});
  const [selectedExam, setSelectedExam] = useState({});
  const [student, setStudent] = useState({});
  const [groups, setGroups] = useState([]);
  const [groupId, setGroupId] = useState();
  const [subjects, setSubjects] = useState([]);
  const [subjectId, setSubjectsId] = useState();
  const [disableNav, setDisableNav] = useState(false);

  const { Option } = Select;

  const next = () => {
    setCurrent(current + 1);
    setLoading(true);
    setCheckedAnswer(question.studentAnswer).then(() => {
      setLoading(false);
    });
  };

  const setIndex = (index) => {
    setCurrent(index);
    setLoading(true);
    setCheckedAnswer(question.studentAnswer).then(() => {
      setLoading(false);
    });
  }

  const done = () => {
    setLoading(true);
    setCheckedAnswer(question.studentAnswer).then(() => {
      collectTotal(selectedExam.id).then(() => {
        setLoading(false);
        setSelectedExam({});
        setCurrent(0);
        setQuestion({});
        setStudent({});
        getPassedStudentExams(examId).then((res) => {
          setSelectedExams(res.data);
          message.success(dictionary?.OperationSuccessful[language]);
        });
      });
    });
  };

  const prev = () => {
    setCurrent(current - 1);
    setLoading(true);
    setCheckedAnswer(question.studentAnswer).then(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    if (!!storageCheckExam) {
      setGroupId(storageCheckExam.groupId);
      setSubjectsId(storageCheckExam.subjectId);
      setExamId(storageCheckExam.id);
    } else {
      setLoading(true);
      teacherSubjects().then((res) => {
        setLoading(false);
        setSubjects(res.data);
      });

      getTeacherGroups().then((res) => {
        setLoading(false);
        setGroups(res.data);
      });
    }
  }, []);

  const setExam = (item) => {
    setSelectedExam(item.exam);
    setStudent(item.students);
  };

  const getStatus = (item) => {
    if (item.exam.status === 0) {
      return <Tag color='red' style={{ width: 200 }}>
        {dictionary?.ExamIsNotStarted[language]}
      </Tag>
    }
    if (item.exam.status === 1) {
      const localExam = exams.filter(x => x.id === examId)[0];
      const endTime = moment(localExam.endTime, 'HH:mm:ss');
      const endDateTime = moment(localExam.endDate).add(endTime.hour(), 'hours').add(endTime.minute(), 'minutes');
      console.log(endDateTime, Date.now(), localExam, endDateTime > moment());
      if (endDateTime > moment()) {
        return <Tag color='orange' style={{ width: 200 }}>
          {dictionary?.ExamIsStarted[language]}
        </Tag>
      }
      else {
        return <Tag color='green' style={{ width: 200 }}>
          <a key='list-loadmore-more' onClick={() => setExam(item)}>
            {dictionary?.CheckAnswers[language]}
          </a>
        </Tag>

      }
    }
    if (item.exam.status === 2) {
      return <Tag color='green' style={{ width: 200 }}>
        <a key='list-loadmore-more' onClick={() => setExam(item)}>
          {dictionary?.CheckAnswers[language]}
        </a>
      </Tag>
    }
    if (item.exam.status === 3) {
      return <Tag color='default' style={{ width: 200 }}>
        {dictionary?.ExamIsChecked[language]}
      </Tag>

    }
  }

  useEffect(() => {
    if (!!groupId && !!subjectId) {
      setLoading(true);
      getPassedExams(groupId, subjectId).then((res) => {
        setLoading(false);
        setExams(res.data);
      });
    }
  }, [subjectId, groupId]);

  useEffect(() => {
    if (!!groupId && !!subjectId && !!examId) {
      setLoading(true);
      getPassedStudentExams(examId).then((res) => {
        setLoading(false);
        setQuestion({});
        setSelectedExam({});
        setCurrent(0);
        setQuestion({});
        setStudent({});
        setSelectedExams(res.data);
      });
    }
  }, [subjectId, groupId, examId]);

  useEffect(() => {
    if (selectedExam.examId) {
      setLoading(true);
      getStudentAnswers(
        selectedExam.id,
        selectedExam.questionIds[current]
      ).then((res) => {
        setLoading(false);
        setQuestion({
          ...res.data,
          studentAnswer: {
            ...res.data.studentAnswer,
            isRight: res.data.studentAnswer.isRight || 0,
          },
        });
      });
    }
  }, [selectedExam, current]);

  return (
    <React.Fragment>
      <Card title={dictionary?.CheckExam[language]} bordered={false}>
        {!storageCheckExam && (
          <Row gutter={24} style={{ textAlign: 'left' }}>
            <Col span={12}>
              <Form.Item label={dictionary?.Group[language]}>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  onChange={(value) => setGroupId(value)}
                >
                  {groups &&
                    groups.map((el) => {
                      return (
                        <Option key={`group${el.id}`} value={el.id}>
                          {el.name}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label={dictionary?.Subject[language]}>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  onChange={(value) => setSubjectsId(value)}
                >
                  {subjects &&
                    subjects.map((el) => {
                      return (
                        <Option key={`subject${el.id}`} value={el.id}>
                          {el.name}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={dictionary?.Exam[language]}>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  onChange={(value) => setExamId(value)}
                >
                  {exams &&
                    exams.map((el) => {
                      return (
                        <Option key={`exam${el.id}`} value={el.id}>
                          {el.name}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        )}
        <Card style={{ padding: 10, backgroundColor: '#F5F5F5' }}>
          <List
            itemLayout='horizontal'
            dataSource={selectedExams}
            renderItem={(item) => (
              <List.Item
                actions={[
                  getStatus(item)
                ]}
              >
                <List.Item.Meta
                  description={
                    <Row>
                      <Col
                        style={{ textAlign: 'left' }}
                        span={12}
                      >
                        {`${item.students.lastName} ${item.students.firstName} ${item.students.middleName}`}
                      </Col>
                      <Col
                        style={{ textAlign: 'left' }}
                        span={12}>
                        {dictionary?.VariantNumber[language]}-
                        {item.exam.variantNumber}
                      </Col>
                    </Row>
                  }
                />
              </List.Item>
            )}
          />
        </Card>
      </Card>

      <Steps current={current} style={{ marginTop: 24 }} size='small'>
        {selectedExam.questionIds &&
          selectedExam.questionIds.map((_, index) => {
            return <Step key={`question${index}`} style={{ cursor: !disableNav ? 'pointer' : '' }} onClick={() => {
              if (!disableNav) {
                setIndex(index)
              }
            }} />;
          })}
      </Steps>
      {
        question.question && question.question.id && (
          <Badge.Ribbon
            text={`${dictionary?.QuestionLevel[language]} - ${question.question.questionLevel}`}
          >
            <div className='steps-content'>
              <div className='site-drawer-render-in-current-wrapper'>
                <Question
                  data={question}
                  setData={setQuestion}
                  student={student}
                  current={current}
                  setDisableNav={setDisableNav}
                />
              </div>
            </div>
          </Badge.Ribbon>
        )
      }
      <div className='steps-action'>
        {current < selectedExam?.questionIds?.length - 1 && (
          <Button type='primary' disabled={disableNav} onClick={() => next()}>
            {dictionary?.Next[language]}
          </Button>
        )}
        {current === selectedExam?.questionIds?.length - 1 && (
          <Button type='primary' disabled={disableNav} onClick={() => done()}>
            {dictionary?.Done[language]}
          </Button>
        )}
        {current > 0 && (
          <Button style={{ margin: '0 8px' }} disabled={disableNav} onClick={() => prev()}>
            {dictionary?.Previous[language]}
          </Button>
        )}
      </div>
    </React.Fragment >
  );
};

export default CheckExam;
